import { Box, Typography, useTheme } from '@mui/material';

import AlertErrorIcon from '../icons/custom-alert/alert-error-icon';
import AlertInfoIcon from '../icons/custom-alert/alert-info-icon';
import AlertSuccessIcon from '../icons/custom-alert/alert-success-icon';
import AlertWarningIcon from '../icons/custom-alert/alert-warning-icon';

const CustomAlert = ({
    severity,
    text,
    subText,
    icon,
    onClick,
    hideIcon,
    styles,
    textStyles,
    textStylesContainer,
}) => {
    const theme = useTheme();
    const getIcon = () => {
        if (hideIcon) return null;
        switch (severity) {
            case 'success':
                return <AlertSuccessIcon />;
            case 'warning':
                return <AlertWarningIcon />;
            case 'info':
                return <AlertInfoIcon />;
            case 'error':
                return <AlertErrorIcon />;
            default:
                return <AlertSuccessIcon />;
        }
    };

    const getBackgroundColor = () => {
        switch (severity) {
            case 'success':
                return theme.palette.info.success;
            case 'warning':
                return theme.palette.info.warning;
            case 'error':
                return theme.palette.info.error;
            case 'info':
                return theme.palette.info.info;
            default:
                return theme.palette.info.default;
        }
    };

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <Box
            className="custom-alert-container"
            sx={{
                ...styles,
                backgroundColor: getBackgroundColor(),
                marginBottom: '15px',
                border: `1px solid ${theme.palette.border.main}`,
            }}
        >
            <Box>{icon ?? getIcon()}</Box>
            <Box sx={{ ...textStylesContainer }}>
                <Typography sx={{ ...textStyles }} fontSize={14}>
                    {text}
                </Typography>
                <Box>
                    <Typography
                        sx={{ color: onClick && '#3291ff', cursor: onClick && 'pointer' }}
                        onClick={handleClick}
                        fontSize={14}
                    >
                        {subText}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default CustomAlert;
